module.exports = __webpack_public_path__ + "media/images/common/instagram-df6b4382eb83716133f49afa2544d327.png";